import styled from "styled-components";

export const ChatFrameContainer = styled.div<{isOpen: boolean}>`
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999999;
  display: flex;
  flex-direction: column;
  font-family: 'Poppins', sans-serif;
  margin-left:auto;
  background-color: ${(props) => props?.theme?.themeConfig?.chatFrame?.styles?.backgroundColor || 'transparent'};
  filter: drop-shadow(0px 0px 30px rgba(0, 0, 0, 0.07));

  visibility: ${(props) => props.isOpen ? 'visible' : 'hidden'};
  height: calc(100% - 57.5px);

  @media screen and (min-width: 768px) {
    position: absolute !important;
    
    height:  ${(props) => props?.theme?.themeConfig?.chatFrame?.styles.height};
    width: ${(props) => props?.theme?.themeConfig?.chatFrame?.styles.width};
    transform: translateY(calc(-100% - 11px));
  }

  &.maximize {
    opacity: 1;
    transform-origin: right bottom;
    transition: width .2s ease 0s, max-height .2s ease 0s, transform .3s cubic-bezier(0,1.2,1,1) 0s, opacity 83ms ease-out 0s;
    z-index: 9999;
  }

  &.minimize {
    transform-origin: right bottom;
    transition: width .5s ease 0s, height .5s ease 0s, max-height .5s ease 0s, transform .6s cubic-bezier(0,1.2,1,1) 0s, opacity 83ms ease-out 0s;
    transform: scale(0);
    opacity: 0;
  }
`;
